import moment from 'moment'

import {DATEFORMATSTRING} from '@/shared/constants'

export const EventsMixin = {
  methods: {
    formatFirstTime: function (item) {
      if ((!item.repeatCount && !item.firstTime) || item.repeatCount === 0) {
        return this.formatTime(item.time)
      } else if (moment(item.firstTime).isBefore(moment('2000-01-01'))) {
        return '?'
      } else {
        var stuff = moment(String(item.firstTime)).format(`${DATEFORMATSTRING} hh:mm:ss a`)
        return stuff
      }
    },

    formatRepeatCount: function (item) {
      if (!item.repeatCount) {
        return 1
      } else {
        return 1 + item.repeatCount
      }
    }
  }
}

export const LookupMixin = {
  methods: {
    getEndpointName: function (id) {
      var endpoint = this.endpoints.find((el) => el._id === id)
      if (endpoint) {
        return endpoint.name
      }
      return 'N/A'
    },

    getLocationTagName: function (id) {
      var locationTag = this.locationTags.find((el) => el._id === id)
      if (locationTag) {
        return locationTag.name
      }
      return 'N/A'
    },

    getMapName: function (id) {
      var map = this.maps.find((el) => el._id === id)
      if (map) {
        return map.name
      }
      return 'N/A'
    },

    getThing: function (id) {
      return this.things.find((el) => el._id === id)
    },

    getThingName: function (id) {
      var thing = this.getThing(id)
      if (thing) {
        return thing.common.name
      }
      return 'N/A'
    },

    getThingTags: function (thing) {
      if (thing.common.tags) {
        return thing.common.tags.join(', ')
      }
      return ''
    },

    getZone: function (id) {
      var zone = this.zones.find((el) => el._id === id)
      if (zone) {
        return zone
      }
      return {}
    },

    getZoneName: function (id) {
      var zone = this.getZone(id)
      if (zone) {
        return zone.name
      }
      return 'N/A'
    }
  }
}

export const TimeMixin = {
  methods: {
    formatTime: function (time) {
      var m = moment(time)
      if (m.isBefore('1000-01-01')) {
        return 'N/A'
      }
      return m.format(DATEFORMATSTRING + ' hh:mm:ss a')
    },

    formatDate: function (time) {
      var m = moment(time)
      if (m.isBefore('1000-01-01')) {
        return 'N/A'
      }
      return m.format(DATEFORMATSTRING + ' hh:mm:ss a')
    },

    pad: function (num) {
      if (num < 10) {
        return '0' + num
      }
      return num
    }
  }
}

export const SettingsMixin = {
  methods: {
    getItemNameLabel: function (label) {
      if (label === '') return 'Name'
      return label
    },

    getItemSerialLabel: function (label) {
      if (label === '') return 'Serial'
      return label
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/mixins.js